import type { RouteRecordRaw } from 'vue-router';

export default {
  path: '/stacklets/:id/console/',
  name: 'stacklet/console',
  component: () => import('@/views/console/console.vue'),
} satisfies RouteRecordRaw;
